import type { HttpHeaders, StringHeaders } from '@captaincause/types'

export const HTTP_DIFT_ID_HEADER = 'x-captain-cause-dift-id'
export const HTTP_CATALOG_ID_HEADER = 'x-captain-cause-catalog-id'
export const HTTP_DIRECT_CAMPAIGN_ID_HEADER =
  'x-captain-cause-direct-campaign-id'
export const HTTP_CAMPAIGN_TOKEN_HEADER = 'x-captain-cause-campaign-token'
export const HTTP_CAMPAIGN_SLUG_HEADER = 'x-captain-cause-campaign-slug'
export const HTTP_MN_TOKEN_HEADER = 'x-captain-cause-fdj-token'
export const HTTP_MN_UNICITY_TOKEN = 'x-captain-cause-unicity-token'
export const SECRET_HTTP_AUTHENTICATION_TOKEN_HEADER =
  'x-captain-cause-authentication-token'
export const SECRET_GG_AUTHENTICATION_TOKEN_HEADER = 'x-captain-cause-all-token'
export const HTTP_DIFT_COUNTRY_CODE_HEADER = 'x-dift-country-code'

export function checkCCAuthenticationToken() {
  if (!process.env.CC_AUTHENTICATION_TOKEN) {
    throw Error(`serverClient: CC authentication token unknown`)
  }

  return true
}

export function createHttpHeaders(
  headers: StringHeaders | undefined = undefined,
  withCCAuthenticationHeader: boolean = true,
): HttpHeaders {
  const httpHeaders = new Headers(headers)
  if (withCCAuthenticationHeader) {
    checkCCAuthenticationToken()

    httpHeaders.append(
      SECRET_HTTP_AUTHENTICATION_TOKEN_HEADER,
      process.env.CC_AUTHENTICATION_TOKEN as string,
    )
  }

  return httpHeaders
}
